<footer class="footer position-absolute">
    <div class="row g-0 justify-content-between align-items-center h-100">
        <div class="col-12 col-sm-auto text-center">
        <span class="fs--1 fw-semi-bold">Copyright 2025. Novalumen, LLC</span>
        </div>
        <div class="col-12 col-sm-auto text-center">
        <span class="fs--1 fw-semi-bold">v1.0.0</span>
        </div>
    </div>
</footer>
